import { GatsbyImage } from "gatsby-plugin-image"
import React from "react"

export default function Logos({ logos, subtitle, dark, light, invert=false }) {
    return (
        <div className={"p40 " + (dark ? " text-dark " : " ") + (light ? " text-black " : " ")}>
            <div className='max-750 ma'>
                <div className={`line--in ${dark ? "dark" : ""}`} data-sal />
                <Grid invert={invert} logos={logos} />
                <div className={`line--in ${dark ? "dark" : ""}`} data-sal />

                {subtitle && (
                    <div className='mt40 fade--in text-center small lh-15' data-sal>
                        {subtitle}
                    </div>
                )}
            </div>
        </div>
    )
}

const Grid = ({ logos, invert }) => {
    return (
        <div className='grid pt20 pb20'>
            {logos.map((logo, index) => (
                <div className={`fade--in text-center ${invert ? "invert" : ""}`} key={index} data-sal>
                    <GatsbyImage image={logo?.gatsbyImageData} alt='Logo' className='logo ma' />
                </div>
            ))}
        </div>
    )
}
